import { AutogenModelHubtranTrx, AutogenRowHubtranTrx } from "./autogen/AutogenModelHubtranTrx";

export class ModelHubtranTrx extends AutogenModelHubtranTrx<RowHubtranTrx> {
	constructor() {
		super(RowHubtranTrx);
	}
}

export class RowHubtranTrx extends AutogenRowHubtranTrx {
}